import { vehicleOwnershipConfig } from "components/shared/vehicleOwnership/config";
import { accessPermitRelationTypesEnum } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { dieselFuelTank } from "helpers/models";
import { requiredField, truckNumber } from "helpers/validators";
import { selectList as accessPermitsList } from "sources/books/accessPermits";
import { list as logistsList } from "sources/books/employees";
import { deviceNumbersList as trackersList } from "sources/books/trackers";
import { list as transportColumnsList } from "sources/books/transportColumns";

const config = {
    number: {
        // field
        label: "Госномер автомобиля",
        inputProps: { name: "number", placeholder: "А 111 АА / 777" },
        required: true,
        type: "carNumber",
        validators: [requiredField, truckNumber],
    },
    brandTypeId: {
        // select
        label: "Марка",
        inputProps: { name: "brandTypeId" },
        dictionary: "carBrandType",
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
    },
    typeId: {
        // select
        label: "Тип автомобиля",
        inputProps: { name: "typeId" },
        dictionary: "carType",
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
    },
    ...vehicleOwnershipConfig,
    logistId: {
        // async-select
        label: "Логист",
        inputProps: { name: "logistId" },
        url: logistsList,
        propName: "fullNameOrEmail",
        menuPortalTarget: document.body,
    },
    trackerId: {
        // async-select
        label: "Трекер",
        inputProps: { name: "trackerId" },
        url: trackersList,
        propName: "deviceNumber",
        menuPortalTarget: document.body,
    },
    transportColumnId: {
        // async-select
        label: "Колонна",
        inputProps: { name: "transportColumnId" },
        url: transportColumnsList,
        propName: "name",
        menuPortalTarget: document.body,
    },
    mechanic: {
        name: {
            label: "ФИО механика",
            inputProps: {
                name: "name",
            },
            bWrapper: "row form-group",
        },
        number: {
            label: "Телефон механика",
            bWrapper: "row",
            inputProps: {
                name: "phoneNumber",
            },
        },
    },
    columnDispatcher: {
        name: {
            label: "ФИО колонного",
            inputProps: {
                name: "name",
            },
            bWrapper: "row form-group",
        },
        number: {
            label: "Телефон колонного",
            bWrapper: "row",
            inputProps: {
                name: "phoneNumber",
            },
        },
    },
    comment: {
        // field
        label: "Cсылки на документы",
        inputProps: { name: "comment" },
        textarea: true,
    },
    needsMaintenanceComment: {
        // field
        label: "Необходимость в ремонте/ТО",
        inputProps: { name: "needsMaintenanceComment" },
        textarea: true,
        nullable: true,
    },
    needsUrgentMaintenance: {
        // checkbox
        label: "Срочная необходимость в ремонте/ТО",
        inputProps: { name: "needsUrgentMaintenance" },
        checkbox: true,
    },
    isInRefuelingSyncList: {
        // checkbox
        label: "Участвует в планировании АЗС",
        inputProps: { name: "isInRefuelingSyncList" },
        checkbox: true,
    },
    accessPermitIds: {
        label: "Полученные разрешения",
        isMulti: true,
        inputProps: { name: "accessPermitIds" },
        url: (props) => accessPermitsList({ filter: { relationType: accessPermitRelationTypesEnum.Car }, ...props }),
        propName: "name",
        menuPortalTarget: document.body,
    },
    fuelTanks: {
        value: [{ ...dieselFuelTank }],
        config: {
            id: {},
            type: {},
            totalVolume: {
                // field
                label: "Объем бака",
                inputProps: {
                    name: "totalVolume",
                    type: "number",
                    min: 0,
                    step: "0.1",
                    pattern: "[0-9]+([.,][0-9]+)?",
                },
            },
            fuelConsumption: {
                // field
                label: "Расход топлива, л/100км",
                inputProps: {
                    name: "fuelConsumption",
                    type: "number",
                    min: 0,
                    step: "0.1",
                    pattern: "[0-9]+([.,][0-9]+)?",
                },
            },
            minimumVolume: {
                // field
                label: "Минимальное кол-во топлива в баке",
                inputProps: {
                    name: "minimumVolume",
                    type: "number",
                    min: 0,
                    step: "0.1",
                    pattern: "[0-9]+([.,][0-9]+)?",
                },
            },
        },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
